import { FC, useState } from 'react'

import './style.scss'
import CONFIG from '../../../config'
import { FormResponseStatus, AuthRoles } from '../../models'
import { LayoutHome } from '../../containers'
import { Button, Title, Text, Icon } from '../../components/UI'
import { ForgotPassword } from '../../components'

const ForgotPasswordPage:FC<{ role?: AuthRoles }> = ({ role = '' })  => {
  const [option, setOption] = useState(0)
  const [email, setEmail] = useState('')

  const onSubmitStatus = (status: FormResponseStatus, email: string) => {
    if(status === 'SUCCESS') {
      setEmail(email)
      setOption(1)
    } else {
      setOption(2)
    }
  }

  return (
    <LayoutHome role={role}>
      {option === 0 &&
        <div className="mt-30">
          <Title component="h2" size="20" weight="bold" align="center">¿Has olvidado la contraseña?</Title>

          <Text size="14" lineHeight="6" align="center" className="mt-30">Para recuperar tu contraseña, ingresa tu número de run o pasaporte y recibirás un correo electrónico con una contraseña temporal</Text>

          <ForgotPassword className="mt-40 lg:mt-50" onSubmit={(status, email) => onSubmitStatus(status, email)} />
        </div>
      }

      {option === 1 &&
        <div className="text-center mt-30">
          <Title component="h2" color="gray-300" size="20" weight="bold">¿Olvidó su contraseña?</Title>

          <Icon name="success" className="mt-40 lg:mt-50" />

          <Text weight="semibold" className="mt-30">Se ha enviado correctamente un código temporal a tu correo electrónico {email}</Text>

          <Button component="link" to={role === 'ADMIN_ROLE' ? CONFIG.ROUTES.ADMIN.HOME : CONFIG.ROUTES.HOME} className="mt-30">IR AL INICIO</Button>
        </div>
      }

      {option === 2 &&
        <div className="text-center mt-30">
          <Title component="h2" color="gray-300" size="20" weight="bold">¿Olvidó su contraseña?</Title>

          <Icon name="error" className="mt-40 lg:mt-50" />

          <Text weight="semibold" className="mt-30">Lo sentimos, no existe una cuenta con esos datos</Text>

          <div className="mt-40">
            {role === 'ADMIN_ROLE' ?
                <Button component="link" to={`${CONFIG.ROUTES.ADMIN.HOME}`} fullWidth>IR AL INICIO</Button>
              :
                <Button component="link" to={`${CONFIG.ROUTES.AUTH.REGISTER.HOME}`} fullWidth>CREAR NUEVA CUENTA</Button>
            }
          </div>
        </div>
      }
    </LayoutHome>
  )
}

export { ForgotPasswordPage }